const PRESETS = {
  dateTimeWithSec: {
    dateStyle: 'medium',
    timeStyle: 'medium',
  },
  dateTimeShort: {
    dateStyle: 'short',
    timeStyle: 'short',
  },
  date: {
    dateStyle: 'medium',
  },
  timeShort: {
    hour: '2-digit',
    minute: '2-digit',
  },
  dateTimeCompact: {
    day: 'numeric',
    month: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  },
} as const satisfies Record<string, Intl.DateTimeFormatOptions>;

type FormatPreset = keyof typeof PRESETS;

const cache = new Map<string, Intl.DateTimeFormat>();

let currentLocale = 'en';

export function setDateTimeFormatLocale(locale: string) {
  currentLocale = locale;
  cache.clear();
}

export function formatDateTime(
  value: Date,
  preset?: FormatPreset,
  overrides?: Intl.DateTimeFormatOptions
): string;
export function formatDateTime(
  value: Date | null | undefined,
  preset?: FormatPreset,
  overrides?: Intl.DateTimeFormatOptions
): string | null | undefined;
export function formatDateTime(
  value: Date | null | undefined,
  preset: FormatPreset = 'dateTimeWithSec',
  overrides: Intl.DateTimeFormatOptions = {}
): string | null | undefined {
  if (value === null || value === undefined) {
    return value;
  }

  const options = { ...PRESETS[preset], ...overrides };

  // Key is options-only; locale changes clear the entire cache via setDateTimeFormatLocale
  const key = JSON.stringify(options);

  if (!cache.has(key)) {
    cache.set(key, new Intl.DateTimeFormat(currentLocale, options));
  }

  return cache.get(key)!.format(value);
}
